import datepicker from '@/custom';
import VueApexCharts from 'vue-apexcharts'
import _ from 'lodash'

export default {
  props: ['item'],
  data : () => {
    return {
      data: [1, 1, 1],
      lan: datepicker,
      thumbnail_size: '100%',
      confirm: false,
      add: false,
      lock: true,
      show : false,
      result : {
        page : { data: '', start: 0, end: 0 },
        ext: { data: '', start: 0, end: 0 },
        detect: { data: '', start: 0, end: 0 },
        resource: { data: '', start: 0, end: 0 }
      },
    }
  },

  components: { apexchart: VueApexCharts },
  computed: {
    chartData() { return this.chartOptions; },
    page_set() {
      let rv = [];
      _.forEach(this.item.page_data, l => _.forEach(l, r => rv.push(r)))
      return rv;
    },
    page_sub() { return _.groupBy(this.page_set, r => r[2]); },
    page_list() {
      let rv = [];
      let roots = _.filter(this.page_set, p => p[0] == 0);
      let subs = this.page_sub;
      let parser = r => r && `${r[8]} -- [${r[5]}, ${r[6] || '-'}, ${r[7]} bytes]` || '-';
      const builder = (r) => {
        let rv = [_.padStart('', r[0] * 2) + parser(r)];
        _.forEach(subs[r[1]], s => rv = rv.concat(builder(s))); // r[1] == this
        return rv;
      }
      _.forEach(roots, r => rv = rv.concat(builder(r)));

      if(!rv.length) {
        let mains = this.page_set;
        rv = _.map(mains, r => { return [_.padStart('', r[0] * 2) + parser(r)] });
      }

      return rv;
    },
    image() { return this.item.thumbnail && 'data:image/png;base64,' + this.item.thumbnail || ''; },
    ext_set() { return this.item.external_data || []; },
    resource_set() { console.log("this.item : ", this.item.resource_data); return this.item.resource_data || []; },
    resource_list() {
      let rv = [];
      let list = this.resource_set;
      _.forEach(list, l => {
        _.forEach(l, r => {
          rv.push(r);
        })
      });
      return rv;
    },
    ext_str() {
      // ver 1.0.1
      let rv = '';
      let parser = r => r && ` -- ${r[8]}\n` || ' -\n';
      let list = this.ext_set;
      _.forEach(list, l => rv += (l[2] + parser(this.find_page(l[1]))));
      return rv;
    },
    ext_list() {
      let rv = [];
      let list = this.ext_set;
      _.forEach(list, l => {
        _.forEach(l, r => {
          rv.push(r);
        })
      });
      return rv;
    },
    detect_set() { return this.item.detect_data || []; },
    detect_list() {
      let rv = [];
      let list = this.detect_set;
      // let parser = r => r && ` -- ${r[8]}` || ' -';
      _.forEach(list, l => {
        _.forEach(l, r => {
          rv.push(`URL - ${r[6]} / Code (${r[2] || r[3]} ${r[5]} ${r[4]})`);
        })
      });
      return rv;
    },
  },
  methods: {
    scroll_page() {
      let div = this.$refs.page_list;
      if(this.result.page.end >= this.item.page_count) { return; }
      if(div.clientHeight + div.scrollTop < div.scrollHeight) { return; }

      let add = _.slice(this.page_list, this.result.page.end, this.result.page.end + 500);
      console.log('slice', add.length, this.result.page.end, this.result.page.end + 500);
      this.result.page.end += add.length;
      this.result.page.data += '\n' + _.join(add, '\n');
    },
    scroll_ext() {
      let div = this.$refs.ext_list;
      if(this.result.ext.end >= this.item.ext_count) { return; }
      if(div.clientHeight + div.scrollTop < div.scrollHeight) { return; }

      let add = _.slice(this.ext_list, this.result.ext.end, this.result.ext.end + 500);
      console.log('slice', add.length, this.result.ext.end, this.result.ext.end + 500);
      this.result.ext.end += add.length;
      this.result.ext.data += '\n' + _.join(add, '\n');
    },
    scroll_detect() {
      let div = this.$refs.detect_list;
      if(this.result.detect.end >= this.item.detect_count) { return; }
      if(div.clientHeight + div.scrollTop < div.scrollHeight) { return; }

      let add = _.slice(this.detect_list, this.result.detect.end, this.result.detect.end + 500);
      console.log('slice', add.length, this.result.detect.end, this.result.detect.end + 500);
      this.result.detect.end += add.length;
      this.result.detect.data += '\n' + _.join(add, '\n');
    },
    scroll_resource() {
      let div = this.$refs.resource_list;
      if(this.result.resource.end >= this.item.resource_count) { return; }
      if(div.clientHeight + div.scrollTop < div.scrollHeight) { return; }

      let add = _.slice(this.resource_list, this.result.resource.end, this.result.resource.end + 500);
      console.log('slice', add.length, this.result.resource.end, this.result.resource.end + 500);
      this.result.resource.end += add.length;
      this.result.resource.data += '\n' + _.join(add, '\n');
    },
    find_page(k) { return _.find(this.page_set, r => r[1] == k); },
    build() {
      let page = _.slice(this.page_list, 0, 500);
      let ext = _.slice(this.ext_list, 0, 500);
      let resource = _.slice(this.resource_list, 0, 500);
      let detect = _.slice(this.detect_list, 0, 500);
      this.result.page.data = _.join(page, '\n');
      this.result.page.end = page.length;
      this.result.ext.data = _.join(ext, '\n');
      this.result.ext.end = ext.length;
      this.result.detect.data = _.join(detect, '\n');
      this.result.detect.end = detect.length;
      this.result.resource.data = _.join(resource, '\n');
      this.result.resource.end = resource.length;
    },
    async get() {
      try {
        this.add = false; this.show = true;
        this.build();
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText) }
    },
  },
  watch: { '$route' (to, from) { console.log("from", from) } },
  created() { console.log('result.detail.vue', 'created'); },
  destroyed() { console.log('result.detail.vue', 'destroyed'); },
  mounted() { console.log('result.detail.vue', 'mounted'); this.get(); },
}